



















import Base from "@/controllers/base.ts";
import { Component } from "vue-property-decorator";
import { Popover } from "ant-design-vue";
import CUser from "./CUser.vue";
import CNav from "./CNav/index.vue";

@Component({
  name: "CHeader",
  components: {
    CUser,
    CNav,
    APopover: Popover
  }
})
export default class CHeader extends Base {
  private created() {
    // undo
  }
}
